import React from "react";

const BloodQueenSacrifice = () => {
  return <div>BloodQueenSacrifice</div>;
};

export default BloodQueenSacrifice;
